import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Router from "./router";
import { useEffect } from "react";

function App() {
	useEffect(() => {
		const storedMode = window.localStorage.getItem('tyi-admin-theme-mode');
		const preferredMode =
			storedMode === 'dark' || storedMode === 'light'
				? storedMode
				: window.matchMedia('(prefers-color-scheme: dark)').matches
				? 'dark'
				: 'light';

		document.documentElement.classList.toggle('dark', preferredMode === 'dark');
		document.documentElement.setAttribute('data-theme', preferredMode);
	}, []);

	return (
		<>
			<Router />
			<ToastContainer position="top-right" autoClose={3000} />
		</>
	);
}

export default App;
